export default "__VITE_ASSET__BUby1Tdb__"